import VueMarkdown from 'vue-markdown-render';
export default defineComponent({
  components: {
    VueMarkdown: VueMarkdown
  }
});